<template>
    <div id="building-preference-form">
        <v-card>
            <v-card-title>
                <v-icon left :color="kingsGold">mdi-home-group</v-icon>Building Preferences
            </v-card-title>
            <v-alert v-if="alert" :color="dangerColor" class="mr-3 ml-3 mb-0" dense icon="mdi-alert-circle" text
                prominent>
                There are one or more required form fields that are empty. Please verify that all required form fields
                are filled in.
            </v-alert>
            <v-card-text>
                <v-form ref="buildingPreferenceForm" v-model="valid" lazy-validation>
                    <v-container class="px-0" fluid>
                        <v-card-subtitle class="pb-1 px-0">
                            <v-icon :color="kingsGold" left>mdi-home-group</v-icon>Building Preference (Please rank two)
                        </v-card-subtitle>
                        <v-alert :color="infoColor" dense icon="mdi-information" text>Please note:
                            <b>Monsignor
                                Wemple</b> residence is designated to female only.</v-alert>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-select v-model="applicant.buildingOption01" :items="getBuildingsOptionOne"
                                    label="Building Preference - First Choice" :rules="buildingOption01Rules" required
                                    @change="resetRoommateOption1">
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-select v-model="applicant.buildingOption02" :items="getBuildingsOptionTwo"
                                    label="Building Preference - Second Choice" :rules="buildingOption02Rules" required
                                    @change="resetRoommateOption2">
                                </v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-select v-model="applicant.buildingUnitPreference"
                                    :items="buildingUnitPreferenceItems" label="Unit Preference"
                                    placeholder="Please select..." :rules="buildingUnitPreferenceRules" required>
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-card-subtitle class="px-0">
                            <v-icon :color="kingsGold" left>mdi-basket</v-icon>Meal Plan Information
                        </v-card-subtitle>
                        <v-row>
                            <v-col cols="12">
                                <v-select v-model="applicant.residenceMealPlan"
                                    hint="Note: These costs are approximate. Final costs are subject to Board approval."
                                    :items="getResidenceMealPlanItems" label="Meal Plan" persistent-hint
                                    placeholder="Please select..." :rules="residenceMealPlanRules" required>
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-card-subtitle class="pb-1 px-0">
                            <v-icon :color="kingsGold" left>mdi-account-group</v-icon>Roommate Requests (Optional)
                        </v-card-subtitle>
                        <v-alert class="mb-0" :color="infoColor" dense icon="mdi-information" text>Roommate
                            request will
                            only be honoured if both students request each other on their applications.</v-alert>
                        <v-row>
                            <v-col cols="12" lg="6">
                                <v-card-subtitle class="pb-1 px-0">
                                    <b>{{ applicant.buildingOption01 || 'Building Preference - First Choice'  }}</b> -
                                    Roommate
                                    Requests (Optional)
                                </v-card-subtitle>
                                <v-alert v-if="!applicant.buildingOption01" :color="infoColor" dense icon="mdi-bell"
                                    text>Please select your first building preference choice.
                                </v-alert>
                                <v-alert v-if="applicant.buildingOption01 && getBuildingRoommateOne == '0'"
                                    :color="warningColor" dense icon="mdi-information" text>The residence building
                                    <b>{{ applicant.buildingOption01 }}</b> does not allow any roommate requests.
                                </v-alert>
                                <v-form ref="roommateRequestForm01">
                                    <v-text-field v-for="i in getBuildingRoommateOne" :key="i"
                                        v-model="applicant.roommateRequest01[i-1]" hide-details
                                        :label="'Roommate Name #' + i">
                                    </v-text-field>
                                </v-form>
                            </v-col>
                            <v-col cols="12" lg="6">
                                <v-card-subtitle class="pb-1 px-0">
                                    <b>{{ applicant.buildingOption02 || 'Building Preference - Second Choice'  }}</b>
                                    -
                                    Roommate
                                    Requests (Optional)
                                </v-card-subtitle>
                                <v-alert v-if="!applicant.buildingOption02" :color="infoColor" dense icon="mdi-bell"
                                    text>Please select your second building preference
                                    choice.</v-alert>
                                <v-alert v-if="applicant.buildingOption02 && getBuildingRoommateTwo == '0'"
                                    :color="warningColor" dense icon="mdi-information" text>The residence building
                                    <b>{{ applicant.buildingOption02 }}</b> does not allow any roommate requests.
                                </v-alert>
                                <v-form ref="roommateRequestForm02">
                                    <v-text-field v-for="i in getBuildingRoommateTwo" :key="i"
                                        v-model="applicant.roommateRequest02[i-1]" hide-details
                                        :label="'Roommate Name #' + i">
                                    </v-text-field>
                                </v-form>
                            </v-col>
                        </v-row>
                        <v-card-subtitle class="px-0">
                            <v-icon :color="kingsGold" left>mdi-history</v-icon>Have you ever lived in a
                            College/University residence before?
                        </v-card-subtitle>
                        <v-row>
                            <v-col cols="12">
                                <v-select v-model="applicant.residencePrevious" :items="residencePreviousItems"
                                    label="Previous residence experience" :rules="residencePreviousRules" required>
                                </v-select>
                            </v-col>
                            <v-col v-if="applicant.residencePrevious == 'Yes'" cols="12">
                                <v-text-field v-model="applicant.residencePreviousLocation"
                                    label="Previous residence location" :rules="residencePreviousLocationRules">
                                </v-text-field>
                                <v-alert class="mt-3 mb-0" :color="successColor" icon="mdi-check" prominent text>I
                                    authorize
                                    King's University College to contact the specified residence for more information
                                    regarding
                                    my residence term.</v-alert>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer>
                </v-spacer>
                <v-btn class="white--text" :color="successColor" :disabled="!valid" @click="nextStep(4)">
                    Next
                </v-btn>
                <v-btn class="white--text" :color="kingsGrey" @click="prevStep(2)">
                    Previous
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
export default {
    name: 'building-preference-form',
    props: {
        applicant: {
            required: true
        },
        formSettings: {
            required: true
        },
        user: {
            required: true
        }
    },
    data() {
        return {
            alert: false,
            buildingUnitPreferenceItems: [{
                    text: 'Single Gender Unit',
                    value: 'Single Gender Unit'
                },
                {
                    text: 'Mixed Gender Unit',
                    value: 'Mixed Gender Unit'
                },
            ],
            buildingUnitPreferenceRules: [
                v => !!v || 'Unit preference is required'
            ],
            buildingOption01Rules: [
                v => !!v || 'First choice building preference is required'
            ],
            buildingOption02Rules: [
                v => !!v || 'Second choice building preference is required'
            ],
            genders: {
                F: 'Female',
                M: 'Male',
                NonBinary: 'NonBinary'
            },
            residenceMealPlanRules: [
                v => !!v || 'Residence meal plan is required'
            ],
            residencePreviousItems: [{
                    text: 'Yes',
                    value: 'Yes'
                },
                {
                    text: 'No',
                    value: 'No'
                }
            ],
            residencePreviousRules: [
                v => !!v || 'Please select an option for previous residence experience'
            ],
            residencePreviousLocationRules: [
                v => !!v || 'Previous residence location is required',
                v => (v && v.length >= 2) || 'Please provide a valid previous residence location',
            ],
            valid: true
        }
    },
    methods: {
        nextStep(val) {
            if (this.$refs.buildingPreferenceForm.validate()) {
                this.alert = false;
                this.$emit('setStep', val);
                this.$nextTick(() => {
                    this.$emit('scrollToTop');
                })
            } else {
                this.alert = true;
                this.$emit('scrollToTop');
            }
        },
        prevStep(val) {
            this.$emit('setStep', val);
            this.$nextTick(() => {
                this.$emit('scrollToTop');
            })
        },
        resetRoommateOption1() {
            // If option 2 becomes option 1
            if (this.applicant.buildingOption01 == this.applicant.buildingOption02) {
                this.$emit('resetBuildingOption2');
                this.resetRoommateOption2();
            }

            this.$refs.roommateRequestForm01.reset();
            this.$emit('resetRoommateOption1');
        },
        resetRoommateOption2() {
            this.$refs.roommateRequestForm02.reset();
            this.$emit('resetRoommateOption2');
        }
    },
    computed: {
        dangerColor() {
            return '#f64e60';
        },
        getBuildingsOptionOne() {
            let buildings = this.user.buildings || [];
            let currentBuildings = [];
            let gender = this.genders[this.applicant.gender] || '';
            let yearOfStudy = "";
            let reg = new RegExp(`^${gender}`, 'i');

            //Year of Study Check
            if(this.applicant.hasOwnProperty("yearOfStudy")){
                yearOfStudy = this.applicant.yearOfStudy
            }

            for (let i = 0; i < buildings.length; i++) {
                let genderBool = false;
                let internationalBool = true;
                let yearBool = false;

                // Gender restriction check
                if (gender && buildings[i].genderRestriction.length > 0) {
                    let restrictions = buildings[i].genderRestriction;

                    for (let j = 0; j < restrictions.length; j++) {
                        if (restrictions[j].match(reg)) {
                            genderBool = true;
                            break;
                        }
                    }
                } else if (gender) {
                    genderBool = true;
                }

                // Year of study restriction check
                // 2025 November 10 update - Upper years only have Upper year residences as options

                let regularyear = ["1","2","3","4"]
                let upperyear = ["2", "3", "4"]

                if (yearOfStudy != "") {
                    if(regularyear.includes(yearOfStudy)){
                        if ( yearOfStudy == "1" && parseInt(buildings[i].minYearOfStudy) == parseInt(yearOfStudy)) {
                            yearBool = true;
                        }else if( upperyear.includes(yearOfStudy) && parseInt(buildings[i].minYearOfStudy) > 1 && parseInt(buildings[i].minYearOfStudy) <= parseInt(yearOfStudy)) {
                            yearBool = true;
                        }
                    }else {
                        if (parseInt(buildings[i].minYearOfStudy) == 1) {
                            yearBool = true;
                        }
                    }
                    
                }

                // if (yearOfStudy != "" && parseInt(buildings[i].minYearOfStudy) > parseInt(yearOfStudy)) {
                //     yearBool = false;
                // }

                // International restriction check
                if (buildings[i].internationalOnly == "1" && this.applicant.internationalStudent == "No") {
                    internationalBool = false;
                }

                if (this.applicant.internationalStudent == "Yes" && parseInt(buildings[i].minYearOfStudy) > 1){
                    internationalBool = false;
                }

                // Upper Year International Students
                if(this.applicant.internationalStudent == "Yes" && upperyear.includes(yearOfStudy) && parseInt(buildings[i].minYearOfStudy) < 2){
                    yearBool = true;
                    internationalBool = true;
                }

                if (genderBool && internationalBool && yearBool) {
                    currentBuildings.push({
                        text: buildings[i].name,
                        value: buildings[i].name
                    });
                }
            }

            // Sort buildings list
            currentBuildings.sort((a, b) => a.text.localeCompare(b.text));

            return currentBuildings;
        },
        getBuildingsOptionTwo() {
            let buildings = this.user.buildings || [];
            let currentBuildings = [];
            let gender = this.genders[this.applicant.gender] || '';
            let yearOfStudy = "";
            let reg = new RegExp(`^${gender}`, 'i');

            //Year of Study Check
            if(this.applicant.hasOwnProperty("yearOfStudy")){
                yearOfStudy = this.applicant.yearOfStudy
            }

            for (let i = 0; i < buildings.length; i++) {
                if (buildings[i].name != this.applicant.buildingOption01) {
                    let genderBool = false;
                    let internationalBool = true;
                    let yearBool = false;

                    // Gender restriction check
                    if (gender && buildings[i].genderRestriction.length > 0) {
                        let restrictions = buildings[i].genderRestriction;

                        for (let j = 0; j < restrictions.length; j++) {
                            if (restrictions[j].match(reg)) {
                                genderBool = true;
                                break;
                            }
                        }
                    } else if (gender) {
                        genderBool = true;
                    }

                    // Year of study restriction check
                    let regularyear = ["1","2","3","4"]
                    let upperyear = ["2", "3", "4"]

                    if (yearOfStudy != "") {
                        if(regularyear.includes(yearOfStudy)){
                            if ( yearOfStudy == "1" && parseInt(buildings[i].minYearOfStudy) == parseInt(yearOfStudy)) {
                                yearBool = true;
                            }else if( upperyear.includes(yearOfStudy) && parseInt(buildings[i].minYearOfStudy) > 1 && parseInt(buildings[i].minYearOfStudy) <= parseInt(yearOfStudy)) {
                                yearBool = true;
                            }
                        }else {
                            if (parseInt(buildings[i].minYearOfStudy) == 1) {
                                yearBool = true;
                            }
                        }
                        
                    }

                    // if (yearOfStudy != "" && parseInt(buildings[i].minYearOfStudy) > parseInt(yearOfStudy)) {
                    //     yearBool = false;
                    // }

                    // International restriction check
                    if (buildings[i].internationalOnly == "1" && this.applicant.internationalStudent == "No") {
                        internationalBool = false;
                    }

                    if (this.applicant.internationalStudent == "Yes" && parseInt(buildings[i].minYearOfStudy) > 1){
                        internationalBool = false;
                    }

                    // Upper Year International Students
                    if(this.applicant.internationalStudent == "Yes" && upperyear.includes(yearOfStudy) && parseInt(buildings[i].minYearOfStudy) < 2){
                        yearBool = true;
                        internationalBool = true;
                    }

                    if (genderBool && internationalBool && yearBool) {
                        currentBuildings.push({
                            text: buildings[i].name,
                            value: buildings[i].name
                        });
                    }
                }
            }

            // Sort buildings list
            currentBuildings.sort((a, b) => a.text.localeCompare(b.text));

            return currentBuildings;
        },
        getBuildingRoommateOne() {
            let buildings = this.user.buildings || [];
            let max = 0;

            if (!this.applicant.buildingOption01) {
                return 0;
            }

            for (let i = 0; i < buildings.length; i++) {
                if (buildings[i].name == this.applicant.buildingOption01) {
                    max = buildings[i].maxRoommateRequest || max;
                }
            }

            return max;
        },
        getBuildingRoommateTwo() {
            let buildings = this.user.buildings || [];
            let max = 0;

            if (!this.applicant.buildingOption02) {
                return 0;
            }

            for (let i = 0; i < buildings.length; i++) {
                if (buildings[i].name == this.applicant.buildingOption02) {
                    max = buildings[i].maxRoommateRequest || max;
                }
            }

            return max;
        },
        getResidenceMealPlanItems() {
            let buildings = this.user.buildings || [];
            let mealPlanItems = [...this.formSettings.mealPlans];
            let required = false;

            // Slice
            mealPlanItems.length = 3;

            if (this.applicant.buildingOption01 || this.applicant.buildingOption02) {
                for (let i = 0; i < buildings.length; i++) {
                    if ((buildings[i].name == this.applicant.buildingOption01 || buildings[i].name == this.applicant.buildingOption02) && buildings[i].mealPlanRequired == "1") {
                        required = true;
                        break;
                    }
                }
            }

            // Required meal plan
            if (required) {
                return mealPlanItems;
            }

            return this.formSettings.mealPlans;
        },
        infoColor() {
            return '#5578eb';
        },
        kingsGold() {
            return '#d7ae28';
        },
        kingsGrey() {
            return '#6d6e71';
        },
        successColor() {
            return '#1bc5bd';
        },
        warningColor() {
            return '#ffb822'
        }
    }
}
</script>

<style scoped>
.col-12 {
    padding-top: 0;
}
</style>